import * as React from 'react';

const SvgMoon = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    {...props}
  >
    <path
      d='M8 15.5C3.86458 15.5 0.5 12.1354 0.5 8C0.5 6.09931 1.2125 4.28681 2.50694 2.89514C3.79375 1.5125 5.53611 0.670141 7.41319 0.523613L8.11042 2.15764C7.23333 2.94028 6.75 4.01597 6.75 5.1875C6.75 7.42778 8.57222 9.25 10.8125 9.25C11.984 9.25 13.0597 8.76667 13.8424 7.88959L15.4764 8.58611C15.3299 10.466 14.4875 12.209 13.1042 13.4951C11.7139 14.7875 9.90069 15.4993 8 15.4993V15.5ZM5.26042 3.0875C4.75208 3.37153 4.28542 3.73611 3.87986 4.17222C2.90903 5.21528 2.375 6.575 2.375 8C2.375 11.1014 4.89861 13.625 8 13.625C9.42639 13.625 10.7854 13.0917 11.8278 12.1222C12.2646 11.716 12.6299 11.2486 12.9146 10.7389C12.2493 10.9917 11.5382 11.125 10.8125 11.125C7.53819 11.125 4.875 8.46181 4.875 5.1875C4.875 4.4632 5.00833 3.75209 5.26042 3.0875Z'
      fill='#9A9292'
    />
  </svg>
);

export default SvgMoon;
